<template>
    <div class="view-login">
        <div class="logo">
            <img src="../../../img/logo-dmb.png" title="DigiMenuBox" />
        </div>

        <div class="intro">
            <h1>Voer onderstaande schermcode in bij dit scherm in uw DigiMenuBox omgeving
            </h1>


        </div>

        <h1 class="code">{{ connectCode }}</h1>

    </div>
</template>

<script>


import { Vue, Options } from 'vue-class-component'
import { get } from 'lodash'

import FindSystemScreen from '@/gql/query/Login/FindSystemScreen.gql'
import StorageKey from '@/js/enum/StorageKey';

import RealtimeSubject from 'common/js/enum/RealtimeSubject';
import RealtimeOperation from 'common/js/enum/RealtimeOperation';

export default Options({
    name: 'Login',
    data: {
        connectCode: ''
    }
})(
    class Login extends Vue {
        error = null;
        code = null;

        submitting = false;

        mounted() {
            document.documentElement.requestFullscreen({ navigationUI: 'hide' });
            
            this.connectCode = this.generateString(4);

            const realtime = this.$di.realtime;

            realtime.connect(`CODE:${this.connectCode}`);

            realtime.handler(RealtimeSubject.SYSTEMSCREEN, this.handleConnectOperation.bind(this));
            realtime.onReconnect(attempts => {

                setTimeout(async () => {

                    if (attempts > 50) {

                        document.location.reload();
                    }
                    else if (attempts > 10) {

                        this.logger.info('Refetching stores & screen because of previous connection failure');

                        // Refetch everything
                        await this.populatePlayerStores();
                        await this.updateScreen();
                    }

                }, 10 * 1000);
            });


        }


        async handleConnectOperation({ data }) {
            window.localStorage.setItem(StorageKey.SCREEN_CODE, data.code);
            this.$router.replace({ name: 'player' });

        }

        generateString(length) {
            let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            let result = '';

            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * 26));
            }

            return result;
        }

        async submit() {

            if (!this.code) {
                this.error = "Je hebt geen code ingevoerd";
                return;
            }

            this.submitting = true;

            try {

                const response = await this.$apollo.query({

                    query: FindSystemScreen,
                    variables: {
                        code: this.code
                    }
                });

                const screen = get(response, 'data.findSystemScreenByCode');

                if (!screen) {
                    this.error = 'De ingevoerde schermcode is ongeldig';
                    this.code = null;
                }
                else {

                    window.localStorage.setItem(StorageKey.SCREEN_CODE, this.code);
                    this.$router.replace({ name: 'player' });
                }
            }
            catch (e) {

                console.error(e);
                this.error = "De code kon niet worden gecontroleerd, controleer de internetverbinding";
            }

            this.submitting = false;
        }
    }
)

</script>
<style src="../../../scss/route/Login.scss" lang="scss"></style>